import React, { useState } from "react";
import { View, StyleSheet, Image } from "react-native";
import { Divider } from "react-native-paper";
import { Text } from "..";
import { ThemeType } from "../../theme/theme";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Inline } from "../layout/inline";
import { Spacer } from "../spacer/spacer";
import upperFirst from "lodash.upperfirst";
import toLower from "lodash.tolower";
import {
  Avatar,
  Button,
  Card,
  Title,
  Paragraph,
  useTheme,
  RadioButton,
  TouchableRipple,
} from "react-native-paper";
import { useConfig } from "../../hooks/useConfig";
import { toHuman } from "../../utils/money";
import { fontSize } from "../../theme/fontSize";
import { testProps } from "../../utils/testProps";

interface MoneygramCardProps extends Record<string, any> {
  last_four_digits: string;
  bank_account_type: string;
  rentAchMinimum: number;
  checkedStatus: string;
  useRadioButton: boolean;
  onPress: Function;
  setSelectedWrapped: Function;
}
export const PaymentMethodMoneygram = (moneygramCardProps: MoneygramCardProps) => {
  const { onPress, setSelectedWrapped, useRadioButton, checkedStatus = null } = moneygramCardProps;
  const theme = useTheme() as ThemeType;
  const iconSize = theme.iconSize.large;
  const config = useConfig();
  const styles = StyleSheet.create({
    cardContainer: {
      width: "100%",
      position: "relative",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1,
      paddingTop: 0,
      paddingBottom: 4,
    },
    moneygramIconSize: {
      width: 80,
      height: 18,
      resizeMode: "contain",
    },
    flexRow: {
      flexDirection: "row",
      justifyContent: "space-around",
      flex: 1,
    },
    text: {
      fontWeight: "bold",
      fontSize: fontSize.medium,
    }
  });
  const MONEYGRAM_FEE = Number(config.moneygramFlatFee);

  if (!useRadioButton) {
    return (
      <>
        <TouchableRipple rippleColor="rgba(0, 0, 0, .32)">
          <View style={styles.cardContainer} accessible={true}>
            <RadioButton.Android
              color={theme.colors.darkBg}
              value="first"
              status={checkedStatus}
              onPress={setSelectedWrapped}
              {...testProps("moneygram-option")}
            />
            <View style={styles.flexRow}>
              <Text tx="homeStack.moneyOrder" style={styles.text} />
              <Image
                style={styles.moneygramIconSize}
                source={require("../../../assets/moneygram.png")}
              />
            </View>
          </View>
        </TouchableRipple>
        <Spacer size="smaller"></Spacer>
        <Divider />
      </>
    );
  }

  return (
    <Button onPress={onPress}>
      <Text tx="homeStack.payMoneygram" />
    </Button>
  );
};
